var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forbidden-wrapper"},[_c('div',{staticClass:"forbidden"},[_c('img',{attrs:{"src":require("@/assets/img/access-forbidden.svg")}}),_c('h6',[_vm._v("\n      Access to page is forbidden\n    ")])])])
}]

export { render, staticRenderFns }